import {
  RolesRequest,
  RolesPermissionsRequest,
  CreateRoleRequest,
  GetRoleRequest,
  UpdateRoleRequest,
  DeleteRoleRequest,
} from '../api/requests';
import type { UserStore } from '~/authentication/stores/user';
import type ApiClient from '~/common/services/ApiClient';
import type { RequestPagination } from '~/common/types';
import { Role } from '../types';

export class RoleService {
  apiClient: ApiClient;
  userStore: UserStore;

  constructor(apiClient: ApiClient, userStore: UserStore) {
    this.apiClient = apiClient;
    this.userStore = userStore;
  }

  async fetch(pagination: RequestPagination, params: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new RolesRequest({
      token: accessToken,
      params: { ...pagination, ...params },
    });

    return this.apiClient.request(request);
  }

  async allPermissions(
    params: Record<string, any>,
    filter?: Record<string, any>,
  ) {
    const accessToken = this.userStore.accessToken;
    const request = new RolesPermissionsRequest({
      token: accessToken,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }

  async create(role: Role) {
    const accessToken = this.userStore.accessToken;
    const request = new CreateRoleRequest({
      token: accessToken,
      role,
    });

    return this.apiClient.request(request);
  }

  async get(roleId: string, params?: { include: string }) {
    const accessToken = this.userStore.accessToken;
    const request = new GetRoleRequest({
      token: accessToken,
      roleId,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }

  async update(roleId: string, role: Role, params?: { include: string }) {
    const accessToken = this.userStore.accessToken;
    const request = new UpdateRoleRequest({
      token: accessToken,
      roleId,
      role,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }

  async delete(roleId: string) {
    const accessToken = this.userStore.accessToken;
    const request = new DeleteRoleRequest({
      token: accessToken,
      roleId,
    });

    return this.apiClient.request(request);
  }
}
